import styled from 'styled-components';

import Card from 'components/Card';
import Rooms from 'containers/Rooms';

// Styled components previously imported from SearchResult.styles.js
const CardStarRating = styled.div`
  font-size: ${props => props.theme.fonts.sizes.normal}px;
  color: ${props => props.theme.palette.primary};
  font-weight: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  flex: 1;
  display: flex;
  align-items: center;
`;

const CardStarText = styled.span`
  flex: 1;
  font-size: ${props => props.theme.fonts.sizes.default}px;
  letter-spacing: 0.38px;
  line-height: ${props => props.theme.fonts.sizes.normal}px;
`;

const CardHighlights = styled.div`
  color: ${props => props.theme.colors.black};
  font-size: ${props => props.theme.fonts.sizes.normal}px;
  text-transform: uppercase;
  padding-top: ${props => props.theme.spacing.gutter}px;
  margin-bottom: ${props => props.theme.spacing.gutter}px;

  ${props => props.theme.breakpoints.tablet`
    display: flex;
    flex-wrap: wrap;
  `}
`;

const CardHighlight = styled.div`
  margin: ${props => props.theme.spacing.gutter / 2}px 0;
  display: block;
  font-size: ${props => props.theme.fonts.sizes.default}px;

  ${props => props.theme.breakpoints.tablet`
    flex: 1 1 50%;
    width: 50%;
  `}
`;

export const StyledHotel = styled.div`
  .linkButton {
    margin: 1rem 0;
  }
  .linkButton--in-list {
    display: block;
  }
`;

export const HotelDetails = styled.div``;

export const HotelName = styled(Card.Title)`
  border-bottom: 0;
  margin: 0 0 ${props => props.theme.spacing.gutter / 2}px;
  padding: 0;
`;

export const HotelRegion = styled.h3`
  font-size: ${props => props.theme.fonts.sizes.normal}px;
  color: ${props => props.theme.palette.neutral};
  text-transform: uppercase;
  font-weight: ${props => props.theme.fonts.normal};
  margin: 0 0 ${props => props.theme.spacing.gutter}px;
  padding: 0;
`;

export const HotelStarRating = styled(CardStarRating)`
  border: 0;

  :last-child {
    margin-bottom: 0;
  }

  ${props => props.theme.breakpoints.tablet`
        margin: ${props.theme.spacing.gutter / 2}px 0 ${props.theme.spacing.gutter}px;
    `}
`;

export const HotelStarText = styled(CardStarText)``;

export const HotelDescription = styled.div`
  color: ${props => props.theme.palette.neutral};
  padding: ${props => props.theme.spacing.gutter}px 0;
  font-size: ${props => props.theme.fonts.sizes.normal}px;
  line-height: 17px;
`;

export const HotelHighlights = styled(CardHighlights)`
  border: 0;
  margin: ${props => props.theme.spacing.gutter}px 0;
  padding: 0;

  ${props => props.theme.breakpoints.tablet`
        display: block;
    `}
`;

export const HotelHighlight = styled(CardHighlight)`
  :last-child {
    margin-bottom: 0;
  }

  ${props => props.theme.breakpoints.tablet`
        flex: unset;
        width: unset;
    `}
`;

export const HotelInfo = styled.div`
  margin: 0 0 ${props => props.theme.spacing.gutter * 4.6}px;
  padding-top: ${props => props.theme.spacing.gutter * 2}px;

  ${props => props.theme.breakpoints.tablet`
    margin: 0 ${props.theme.spacing.gutter * 2}px ${props.theme.spacing.gutter * 8}px;
    padding-top: 0;
    padding-right: 5%;
  `}
`;

export const HotelWrapper = styled.div`
  ${props => props.theme.breakpoints.tablet`
  `}
`;
